
import './ProfileList.scss';
export default function ProfileList(props: any) {
    return (
        <ul className="sc-jGkVzM fvbKsb ">{props.children}</ul>
    );
}